import { render, staticRenderFns } from "./EarnCoin.vue?vue&type=template&id=0a183108&scoped=true&"
import script from "./EarnCoin.vue?vue&type=script&lang=ts&"
export * from "./EarnCoin.vue?vue&type=script&lang=ts&"
import style0 from "./earn_coin.scss?vue&type=style&index=0&id=0a183108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a183108",
  null
  
)

export default component.exports